<template >
  <div class="container is-fluid " style="min-height: 92vh; padding-top: 20px" >
    <div class="tile is-ancestor is-mobile " style="padding-top: 5px;padding-left: 5px;" >
      <div
        class="tile is-vertical is-parent "
        :class="$mq === 'mobile' ? 'is-12' : ($mq === 'tablet' ? 'is6' : 'is-3')" >
        <div class="tile is-child box">
          <div class="columns is-multiline is-mobile " style="text-align:center" >
						<div class="column is-12-mobile " >
							<img src="@/assets/images/settings.png" style="max-height:200px !important" >
						</div>
            <br/>
						<b-field
							class="w100"
							label="E-Mail"
							label-position="on-border" >
							<b-input
								v-model="correo"
								icon="user"></b-input>
						</b-field>
						<b-field
							class="w100"
							label="Clave"
							label-position="on-border">
							<b-input
								type="password"
								v-model="claveSinMd5"
								icon="lock"
								password-reveal >
							</b-input>
						</b-field>
						<div class="columns is-mobile w100" >
							<div class="column " >
								<b-button
									class="is-success align-center has-text-weight-semibold"
									@click="login()" >
									<img src="@/assets/icons/login-4.png" style="max-height:30px !important" >
									Iniciar Sesión
								</b-button>
							</div>
						</div>
          </div>
        </div>
      </div>
      <div class="tile is-parent" v-if="$mq !== 'mobile'" >
        <div class="container is-fluid">
          <div :style="`height:450px;background-image:url(images/administrador.jpg);background-size:cover;background-position:center`" >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import md5 from 'js-md5'
import Cookie from 'js-cookie'
export default {
	data () {
		return {
			correo: null,
			reglasUsuario: [
				v => !!v||'Ingresa tu Usuario',
				v => v  &&  v.indexOf(" ") === -1 || 'No puede ingresar espacios en blanco',
				(v) => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(v) || 'Ingrese un email valido.'
			],
			reglasClave: [
				v=> !!v||'Ingresa tu Clave',
				v =>  v  && v.indexOf(" ") === -1 || 'No puede ingresar espacios en blanco'
			],
			cargando: false,
			claveSinMd5: null,
			intentos: 0
		}
  },
  created () {
		this.logout()
  },
	methods: {
		async login () {
			if (!this.correo || this.correo == null ||
					!(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(this.correo))) {
				this.$alertifyNR.genericAlert('Ingrese un E-Mail valido')
				return
			}
			if (this.claveSinMd5 == null || !this.claveSinMd5 ) {
				this.$alertifyNR.genericAlert("No se ha ingresado tu Clave")
				return
			}
			let existe = this.claveSinMd5.indexOf(" ")
			if (existe > -1) {
				this.$alertifyNR.genericAlert("No se Permiten espacios en Clave","ERROR")
				return
			}
			this.claveSinMd5 = this.claveSinMd5.trim()
			let hash = md5.create()
			hash.update(this.claveSinMd5)
			const clave = hash.hex()
			const params = [
				this.correo,
				clave
			]
			try {
				const resultado = await this.$api.ejecutar("SPR_LOGIN", params)
				if (resultado != null) {
					this.$alertifyNR.genericAlert(resultado[0].message, resultado[0].status)
					if (resultado[0].status === 'SUCCESS') {
						this.$store.commit('setUser', resultado[0])
						this.$store.commit('setToken', resultado[0].token)
						Cookie.set('viaAdminToken', resultado[0].token)
						this.$router.push({ name: 'PaginaPrincipal' })	
					}
				}
			} catch (error) {
				if (error.message === "Network Error") {
					this.$alertifyNR.genericAlert(error.name + ': <b>Error de Red</b>', "ERROR")
				} else {
					this.$alertifyNR.genericAlert(error.name + ': ' + error.message, "ERROR")
				}
			}
		},
		async logout () {
			const viaAdminToken = Cookie.get("viaAdminToken")
			if (viaAdminToken != null) {
				try {
					const resultado = await this.$api.ejecutar("SPR_LOGOUT", [ viaAdminToken ])
					if (resultado != null) {
						this.$alertifyNR.genericAlert(resultado[0].message, resultado[0].status)
						if (resultado[0].status === 'SUCCESS') {
							Cookie.remove('viaAdminToken')
							this.$store.commit('setUser', null)
							this.$store.commit('setToken', null)
						}
					}
				} catch (error) {
					if (error.message === "Network Error") {
						this.$alertifyNR.genericAlert(error.name + ': <b>Error de Red</b>', "ERROR")
					} else {
						this.$alertifyNR.genericAlert(error.name + ': ' + error.message, "ERROR")
					}
				}
			}
		}
	}
}
</script>